import React, { useContext, useState } from "react";
import Card from "../../../../UX/Card/Card";
import PrintTable from "./PrintTable";
import OffsetTable from "./OffsetTable";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import Modal from "../../../../UX/Modal/Modal";
import Verspreiddatum from "../Verspreiddatum";
import { VerspreidenContext } from "../../../../Providers/VerspreidenProvider";
import StepContainer from "../../../../UX/StepContainer/StepContainer";

const QuantityOptions = props => {
    const [modal, setModal] = useState(false);
    const { printPrices, offsetPrices } = useContext(ProductOptionStepsContext);
    //     const {verspreidDatums} = useContext(VerspreidenContext);
    // console.log(verspreidDatums);
    if (!printPrices && !offsetPrices) {
        return null;
    }

    const toggleModal = () => setModal(!modal);

    const Buttons = (
        <>
            <button
                onClick={() => toggleModal()}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm"
            >
                <i className="fas fa-info-circle" /> Levervoorwaarden
            </button>
        </>
    );

    const stepNormal = {
        description: <> Selecteer oplage en levertermijn</>,
        step_description: (
            <>
                Aan de rechterzijde zie je één of twee tabellen (digitaal en/of
                offset drukwerk). Kijk eerst goed naar welke oplage je nodig
                hebt en wanneer je jouw drukwerk wilt ontvangen. Bovenaan de
                tabellen staan de levertermijnen met informatie over de
                verwachte levering en de bijbehorende deadlines. De prijzen zijn gebaseerd op 1 origineel bestand.
                Mocht je nog vragen hebben of een afwijkende oplage / levertermijn willen
                kiezen, dan kun je contact met ons opnemen via de{" "}
                <a
                    className="text-blue-500 hover:underline cursor-pointer"
                    onClick={() => Intercom("show")}
                >
                    chat-functie
                </a>
                .
            </>
        ),
        id: "qty"
    };

    const stepVerspreiden = {
        description: <> Selecteer leverperiode</>,
        step_description: (
            <>
                Gebruik je datumprikker hiernaast om een leverperiode aan te
                geven. Kom je er niet uit? Neem dan contact op via de{" "}
                <a
                    className="text-blue-500 hover:underline cursor-pointer"
                    onClick={() => Intercom("show")}
                >
                    chat-functie
                </a>
                .
            </>
        ),
        id: "qty"
    };

    return (
        <>
            {!printPrices && offsetPrices.prices.length === 1 ? (
                <StepContainer step={stepVerspreiden} buttons={Buttons}>
                    <div className="w-full bg-white p-4 rounded border border-gray-200">
                        <div className="w-full">
                            <Verspreiddatum items={offsetPrices} />
                        </div>
                    </div>
                </StepContainer>
            ) : (
                <StepContainer step={stepNormal} buttons={Buttons}>
                    {((printPrices &&
                        printPrices.prices[0].options[0].price_discount) ||
                        (offsetPrices &&
                            offsetPrices.prices[0].options[0]
                                .price_discount)) && (

                            <div
                                style={{
                                    borderRightColor: "#C6F6D5",
                                    borderTopColor: "#C6F6D5",
                                    borderBottomColor: "#C6F6D5"
                                }}
                                className="rounded bg-green-100 border-l-4 border-green-500 text-green-700 border p-4 w-full mb-8"
                                role="alert"
                            >
                                <h5 className="font-bold mb-1">
                                    Extra korting op deze producten!
                                </h5>
                                <p className="">
                                    De gekozen productcombinatie is in de
                                    aanbieding, hieronder zie je de prijzen met
                                    korting.
                                </p>
                            </div>

                    )}
                    <div className="w-full mb-8">
                        <PrintTable items={printPrices} />
                    </div>
                    <div className="w-full mb-8">
                        <OffsetTable items={offsetPrices} />
                    </div>
                </StepContainer>
            )}

            <Modal size="medium" onClose={toggleModal} display={modal}>
                <div className="cell homepage-title">
                    <h1>Levertermijnen</h1>
                    <p>
                        <b>
                            Hoe werken Nederlands snelste levertermijnen van
                            24-drukwerk?
                        </b>
                        <br />
                        De levertermijnen van 24-drukwerk gaan in op het moment
                        dat wij de betaling hebben ontvangen. Let op:{" "}
                    </p>
                    <h2>
                        *De levertijden gelden vanaf de huidige werkdag, mits de
                        bestelling en betaling bij ons binnen is vóór{" "}
                        <font color="#ff0000">de deadlines.</font>
                    </h2>
                    Dit geldt op voorwaarde dat we vóór de deadline de bestanden
                    in goede orde en volgens onze{" "}
                    <a href="/page/aanleverspecificaties">
                        aanleverspecificaties
                    </a>{" "}
                    ontvangen. Bij aanlevering na de deadline wordt de levertijd
                    berekend vanaf de volgende werkdag. <br />
                    <br />
                    <b>
                        Snel drukwerk nodig, maar je bent te laat voor de
                        gewenste deadline?
                    </b>
                    <br />
                    Neem direct <a href="contact">contact</a> met ons op! Bij
                    24-drukwerk doen wij er alles aan om je bestelling alsnog op
                    tijd te leveren. <br />
                    <br />
                    Natuurlijk zal 24-drukwerk met volle inzet jouw drukwerk
                    binnen de gewenste levertermijn proberen te leveren. Echter,
                    de bezorging blijft natuurlijk mensenwerk, van bestelling
                    tot aan de deur. De transportleveranciers van 24-drukwerk
                    hanteren een levering-op-tijd-garantie van 95%.
                    Vanzelfsprekend doen wij er alles aan om je te helpen waar
                    het maar kan. Als je vragen of problemen hebt, dan kun je
                    met ons <a href="contact">contact</a> opnemen.
                    <br />
                    <br />
                    De levertermijnen van 24-drukwerk zijn een indicatie. Dit
                    betekent dat er geen zogenaamde "fatale termijn" is die moet
                    leiden tot aansprakelijkheid van 24-drukwerk bij
                    overschrijding van de gewenste levertermijn. Echter wij
                    kunnen je garanderen dat wij nimmer de intentie hebben om af
                    te wijken van onze levertermijnen. Voor het uitsluiten van
                    geschillen e.d. moeten wij dit formeel melden op onze
                    website.
                    <br />
                    <br />
                    <b>Je bent logistiek ‘in control’</b>
                    <br />
                    Na voltooiing van de bestelling krijgt je bestelling de
                    status "Betaling ontvangen". Onze medewerkers controleren de
                    bestelling en bestand(en) om jouw drukwerk zo snel mogelijk
                    te kunnen drukken. Als je bestelling akkoord is, dan
                    ontvangt je een mail met de status "in productie". Dit kun
                    je zelf ook realtime inzien via{" "}
                    <a href="mijn-account">Mijn account</a>. Als je niet
                    aanwezig bent wanneer de bestelling op een opgegeven adres
                    wordt aangeboden, dan zal de transporteur de bestelling de
                    volgende werkdag opnieuw bij je aanbieden. <br />
                    <br />
                    <b>Transport</b>
                    <br />
                    Alle producten van 24-drukwerk worden verstuurd met
                    professionele transportbedrijven. Je kunt op '
                    <a href="mijn-account">Mijn account</a>' zien, wanneer jouw
                    bestelling is verzonden. <br />
                    <br />
                    <b>Je bestelling afhalen</b>
                    <br />
                    Indien gewenst kun je jouw bestelling ook afhalen bij ons in
                    's-Hertogenbosch, dit kun je tijdens het plaatsen van de
                    bestelling aangeven.
                    <br />
                    <br />
                    <b>VANDAAG Levering of VANDAAG afhalen</b>
                    <br />
                    Als je voor 10:00 uur de bestelling plaatst met een
                    spoedlevering, dan kunt je de bestelling vandaag nog laten
                    leveren of zelf afhalen. Deze levertermijn geldt alleen voor
                    levering in Nederland. Voor vragen kun je natuurlijk ook{" "}
                    <a href="contact">contact</a> met ons opnemen. Wij helpen je
                    graag verder. <br />
                    <br />
                    <p />
                </div>
            </Modal>
        </>
    );
};

export default QuantityOptions;
